import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Avatar,
  Typography,
  Box,
  CircularProgress,
  Modal,
} from "@mui/material";
import {
  doc,
  updateDoc,
  getDocs,
  query,
  where,
  collection,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../@shared/firebase/config";

const screenHeight = window.innerHeight;

const modalHeight = screenHeight * 0.6;
const modalWidth = modalHeight * (4 / 5);

const backgroundImage = require("../@shared/assets/game_menu.png");

const EditProfileModal = ({ visible, onClose, userData }) => {
  const [username, setUsername] = useState(userData.username || "");
  const [imgUrl, setImgUrl] = useState(userData.imgUrl || "");
  const [isSaving, setIsSaving] = useState(false);
  const [localImage, setLocalImage] = useState(null);

  useEffect(() => {
    if (visible) {
      setUsername(userData.username);
      setImgUrl(userData.imgUrl);
    }
  }, [visible]);

  const handleSave = async () => {
    const trimmedUsername = username.trim().toLowerCase();
    if (!trimmedUsername) {
      alert("Username cannot be empty.");
      return;
    }

    setIsSaving(true);

    try {
      let updatedImgUrl = imgUrl;

      if (localImage) {
        const imageRef = ref(storage, `profile_images/${userData.id}.jpg`);
        await uploadBytes(imageRef, localImage);
        updatedImgUrl = await getDownloadURL(imageRef);
      }

      if (trimmedUsername !== userData.username.toLowerCase()) {
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("username", "==", trimmedUsername));
        const snapshot = await getDocs(q);
        const takenByOther = snapshot.docs.find(
          (doc) => doc.id !== userData.id
        );

        if (takenByOther) {
          alert("Username taken. Please choose a different one.");
          setIsSaving(false);
          return;
        }
      }

      await updateDoc(doc(db, "users", userData.id), {
        username: trimmedUsername,
        imgUrl: updatedImgUrl,
      });

      alert("Profile updated!");
      onClose();
    } catch (err) {
      console.error("Error saving profile:", err);
      alert("Something went wrong while updating your profile.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      open={visible}
      onClose={onClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box sx={styles.modalContainer}>
        <img
          src={backgroundImage}
          alt="Background"
          style={styles.backgroundImage}
        />
        <Typography
          variant="h6"
          sx={{
            color: "#fff",
            fontWeight: "bold",
            mb: 2,
            textAlign: "center",
            padding: "10px 20px",
            borderRadius: "5px",
            backgroundColor: "#00000080",
          }}
        >
          Edit Profile
        </Typography>

        <Box sx={styles.avatarRow}>
          <Box
          //   onClick={pickImage}
          >
            <img
              source={
                imgUrl
                  ? { uri: imgUrl }
                  : require("../@shared/assets/icons/profile_icon.png")
              }
              style={styles.avatar}
            />
            <Typography style={styles.avatarHint}>Tap to change</Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ marginVertical: "16px" }}>
        <Typography style={styles.label}>Username</Typography>
        <TextField
          variant="outlined"
          color="primary"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </Box>

      <Button onClick={onClose} color="secondary">
        Cancel
      </Button>
      <Button
        onClick={handleSave}
        variant="contained"
        color="primary"
        disabled={isSaving}
      >
        {isSaving ? <CircularProgress size={24} color="inherit" /> : "Save"}
      </Button>
    </Modal>
  );
};

const styles = {
  modalContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 2,
    height: { xs: "70%", md: "60%" },
    width: { xs: "95%", md: "30%" },
    position: "absolute",
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  modalContentWrapper: {
    width: modalWidth,
    height: modalHeight,
  },
  avatarRow: {
    alignItems: "center",
    marginBottom: 10,
  },
  avatar: {
    width: 70,
    height: 70,
    borderRadius: 35,
    borderColor: "#fff",
    borderWidth: 2,
  },
  avatarHint: {
    color: "#fff",
    textAlign: "center",
    fontSize: 12,
    marginTop: 6,
  },
  modalContent: {
    width: modalWidth,
    height: modalHeight,
    paddingTop: "5.6%",
    paddingLeft: "8%",
    paddingRight: "8%",
    paddingBottom: "12%",
    borderRadius: 16,
    elevation: 5,
    borderColor: "#fff",
    position: "relative",
  },
  incrementRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
  },
  incrementButton: {
    width: 50,
  },
  toggleRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    my: 1,
    alignItems: "center",
  },
  buttonRow: {
    mt: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
};

export default EditProfileModal;
